import { brand } from '@/config/brand';

/** 푸터(Footer) — 한 줄 저작권 + 버전 표기. */
export function WorkspaceFooter() {
  return (
    <footer className="mx-4 mt-8 flex flex-wrap items-center justify-between gap-3 border-t py-5 text-xs text-muted-foreground sm:mx-8">
      <span className="inline-flex items-center gap-1.5">
        {brand.group} · {brand.name}
        <span className="rounded-md border px-1.5 py-px">Workspace</span>
      </span>
      <span>{brand.legal.copyright}</span>
    </footer>
  );
}
